// extracted by mini-css-extract-plugin
export default {"zoomModal":"r1-z"};